module.exports = __webpack_public_path__ + "static/media/cg_swiper_y.d5cd691d.jpg";